import * as React from 'react';
import PropTypes from 'prop-types';

const SvgAchievementsTrophyNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#achievements_trophy_normal_xsmall_svg__clip0_138_777)">
        <path
          d="M13.5.98V0h-11v.98H0v2.45a1.933 1.933 0 00.79 1.8 7.9 7.9 0 00.71.42V4.5a.565.565 0 01-.14-.09C1.05 4.2 1 3.98 1 3.43V1.98h1.5V7a4.079 4.079 0 001.88 3.24l3.13 1.79v1.395L4 15.3v.7h8v-.7l-3.485-1.857v-1.466l3.1-1.737A4.079 4.079 0 0013.5 7V1.98H15v1.45c0 .55-.05.77-.35.98a.984.984 0 01-.15.09v1.15c.333-.18.573-.32.72-.42a1.943 1.943 0 00.78-1.8V.98h-2.5zM6.69 15L8 14.3l1.31.7H6.69zm5.81-8a3.06 3.06 0 01-1.38 2.37l-3.06 1.75h-.12L4.88 9.37A3.062 3.062 0 013.5 7V1h9v6z"
          fill=""
        />
      </g>
      <defs>
        <clipPath id="achievements_trophy_normal_xsmall_svg__clip0_138_777">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
SvgAchievementsTrophyNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgAchievementsTrophyNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgAchievementsTrophyNormalXsmall;
